export type ErpNavigationGate = {
  requiredErpChapter?: string;
  requiredErpSubChapter?: string;
};

/**
 * Single registry shared by both static menu builders. These keys are the
 * proved live V4 chapters only; absence means the section remains outside this
 * migration slice.
 */
export const ERP_NAVIGATION_GATES = {
  customers: { requiredErpChapter: 'customer' },
  tariffs: { requiredErpChapter: 'tariff' },
  messages: { requiredErpChapter: 'customer_msg' },
  accounting: { requiredErpChapter: 'accountancy' },
  map: { requiredErpChapter: 'map' },
  transport: { requiredErpChapter: 'transport' },
  transportSchedule: { requiredErpSubChapter: 'sub_transport_schedule' },
  advertisement: { requiredErpChapter: 'advertisement' },
  employeeTimesheet: { requiredErpSubChapter: 'sub_employee_timesheet' },
  employeeReports: { requiredErpSubChapter: 'sub_employee_task_report' },
  employeeMotivation: { requiredErpSubChapter: 'sub_employee_motivation' },
  employeeVacation: { requiredErpSubChapter: 'sub_employee_vacation_leave' },
} as const satisfies Record<string, ErpNavigationGate>;

export type ErpNavigationGateKey = keyof typeof ERP_NAVIGATION_GATES;

export function erpNavigationGate(key: ErpNavigationGateKey): ErpNavigationGate {
  return ERP_NAVIGATION_GATES[key];
}
